var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloorHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1125 56.25h-1050c-10.312 0-18.75 8.4375-18.75 18.75v1050c0 10.312 8.4375 18.75 18.75 18.75s18.75-8.4375 18.75-18.75v-970.5l150 300v520.5c0 10.312 8.4375 18.75 18.75 18.75s18.75-8.4375 18.75-18.75v-506.25h637.5v506.25c0 10.312 8.4375 18.75 18.75 18.75s18.75-8.4375 18.75-18.75v-520.5l150-300v970.5c0 10.312 8.4375 18.75 18.75 18.75s18.75-8.4375 18.75-18.75v-1050c0-10.312-8.4375-18.75-18.75-18.75zm-199.12 375h-651.75l-168.75-337.5h989.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1019.6 140.06c-3.375-5.4375-9.375-8.8125-15.938-8.8125h-807.38c-6.5625 0-12.562 3.375-15.938 8.8125s-3.75 12.375-0.75 18.188l112.5 225c3.1875 6.375 9.75 10.312 16.688 10.312h582.38c7.125 0 13.5-3.9375 16.688-10.312l112.5-225c3-5.8125 2.625-12.75-0.75-18.188zm-438.38 28.688v75h-317.06l-37.5-75zm-298.31 112.5h298.31v75h-260.81zm596.62 75h-260.81v-75h298.31zm56.25-112.5h-317.06v-75h354.56z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorHigh);
export default __webpack_public_path__ + "static/media/floor_high.3aaa38ced110a4c67aaefe45f51cb217.svg";
export { ForwardRef as ReactComponent };